import React from 'react';

class TableNavChange extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectIndex: 0,
        };
    }
    changeNav(event) {
        var id = event.currentTarget.getAttribute('id');
        var distributionStatus = this.props.distributionStatus;
        var activeItem = null;
        for (var i = 0; i < distributionStatus.length; i++) {
            if (distributionStatus[i].id == id) {
                distributionStatus[i].active = true;
                activeItem = distributionStatus[i];
            } else {
                distributionStatus[i].active = false;
            }
        }
        this.setState({
            distributionStatus: distributionStatus
        })
        if (typeof this.props.changeNav == "function") {
            this.props.changeNav(activeItem)
        }

    }

    render() {
        return (
            <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                <ul className="zk-maiwrap-nav">
                    {this.props.distributionStatus.map((item, index) =>
                        <li className={item.active ? "active" : ""} key={index} id={item.id} index={index} onClick={(event) => this.changeNav(event)}>
                            {item.title}
                            {
                                item.active ?
                                    item.num ?
                                        <i className="successColor">（{item.num}）</i> :
                                        !this.props.noShowNum ?
                                            <i className="successColor">（0）</i> :
                                            null :
                                    this.props.allShow ?
                                        <i>（{item.num}）</i> :
                                        null
                            }

                        </li>
                    )}
                </ul>
                {
                    this.props.allShow ? <span className='popoverCommon' style={{ backgroundColor: '#000', color: '#fff', borderRadius: '50%', position: 'absolute', right: '4px', top: '11px', width: '16px', height: '16px', display: 'flex' }}>
                        <span style={{ marginLeft: '5px' }}>？</span>
                        <div className='popoverCommon-warn' style={{ bottom: '24px', color: '#000', left: '-10px', fontSize: '12px', width: '400px' }}>
                            <div>买家申请售后，且售后地址与官方仓地址一致，则为官方仓售后单</div>
                            <div>售后中：买家申请售后，卖家未处理或已同意售后申请等待买家上传快递单号的订单为售后中</div>
                            <div>售后完成：卖家拒绝售后申请、买家取消售后申请、买家回传快递单号后系统成功创建官方仓售后单的订单为售后完成</div>
                        </div>
                    </span> : null

                }
            </div>
        );
    }
}

export default TableNavChange;



// WEBPACK FOOTER //
// ./src/components/tableNavChange/tableNavChange.jsx